import { render, staticRenderFns } from "./RevenuesList.vue?vue&type=template&id=596b17f8&scoped=true"
import script from "./RevenuesList.vue?vue&type=script&lang=ts"
export * from "./RevenuesList.vue?vue&type=script&lang=ts"
import style0 from "./RevenuesList.vue?vue&type=style&index=0&id=596b17f8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "596b17f8",
  null
  
)

export default component.exports